import Types from 'actions/types'
import Immutable from 'seamless-immutable'
import { combineReducers } from 'redux'

const attempting = (state = Immutable(false), action) => {
  switch (action.type) {
    case Types.QUOTING_QUOTE_ADD_REVISION_ATTEMPT:
    case Types.QUOTING_QUOTE_ADD_ATTEMPT: return true
    case Types.DIALOG_SHOW:
    case Types.DIALOG_HIDE:
    case Types.QUOTING_QUOTE_ADD_REVISION_SUCCESS:
    case Types.QUOTING_QUOTE_ADD_REVISION_FAILURE:
    case Types.QUOTING_QUOTE_ADD_SUCCESS:
    case Types.QUOTING_QUOTE_ADD_FAILURE: return false
    default: return state
  }
}

const error = (state = null, action) => {
  switch (action.type) {
    case Types.DIALOG_SHOW:
    case Types.DIALOG_HIDE:
    case Types.SHOW_ADD_QUOTE_DIALOG:
    case Types.HIDE_ADD_QUOTE_DIALOG:
    case Types.QUOTING_QUOTE_ADD_ATTEMPT:
    case Types.QUOTING_QUOTE_ADD_SUCCESS: return null
    case Types.QUOTING_QUOTE_ADD_FAILURE: return action.error
    default: return state
  }
}

export default combineReducers({
  attempting,
  error,
})
